import React, { Component } from "react";
import _ from "lodash";
import Post from "./Post";

export default class CouplePost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      source: [],
      slide: 0,
      type: "image",
    };
  }

  render() {
    return (
      <div className="card-columns" style={{ columnCount: 2 }}>
        {this.props.post.map((element,index) => (
          <Post
            index={index}
            post={element}
            openModalDelete={this.props.openModalDelete}
            openLikeModal={this.props.openLikeModal}
            openModalPostPrivate={this.props.openModalPostPrivate}
            showLiteBox={this.showLiteBox}
          />
        ))}
      </div>
    );
  }
}
